import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "position-relative" }

import PreviewHeader from "@/components/Every24HoursReportPreviewParts/PreviewHeader.vue";
import PreviewCharts from "@/components/Every24HoursReportPreviewParts/PreviewCharts.vue";
import {
  DEFAULT_OUTPUT_TIME,
  DEFAULT_DRIVING_DISTANCE,
  DEFAULT_DRIVING_TIME
} from "@/services/consts/every_24_hours_report";
import { formatDateTimeWithMilliseconds } from '@/services/functions';
import every24HoursPreviewType from "@/types/responses/every24HoursPreview";
import { Ref, ref, onMounted } from "vue";
import moment from 'moment';


export default /*@__PURE__*/_defineComponent({
  __name: 'PreviewBody',
  props: {
    deliveryPlanRecords: {},
    downloading: { type: Boolean },
    isShowableDownloadButton: { type: Boolean }
  },
  emits: ['changeDetailData'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

const selectedOutputTime: Ref<string[]> = ref([]);
const chartDetails: Ref<{
  deliveryPlanDate: string,
  displayStartTime: string,
  drivingDistance: string,
  drivingTime: string,
}[]> = ref([]);
const defaultChartDetail = {
  deliveryPlanDate: '',
  displayStartTime: '',
  drivingDistance: DEFAULT_DRIVING_DISTANCE,
  drivingTime: DEFAULT_DRIVING_TIME,
};

onMounted(() => {
  for (let i = 0; i < props.deliveryPlanRecords.length; i++) {
    selectedOutputTime.value.push(DEFAULT_OUTPUT_TIME);
    chartDetails.value.push({ ...defaultChartDetail });
  }
});

function changeChartDetail(values: {
    index: number,
    displayStartTime: number,
    drivingDistance: string,
    drivingTime: string
    xLabel: string[]
    speed: number[][]
    distance: number[][]
    rotationSpeed: number[][]
  }
) {
  const deliveryPlanDate = moment(values.displayStartTime).format("YYYY-MM-DD");
  const displayStartTime = moment(values.displayStartTime).format("HH:mm:ss");
  chartDetails.value[values.index] = {
    deliveryPlanDate: deliveryPlanDate,
    displayStartTime: displayStartTime,
    drivingDistance: values.drivingDistance,
    drivingTime: values.drivingTime
  }

  emit('changeDetailData', {
    delivery_plan_id: props.deliveryPlanRecords[values.index].delivery_plan_id,
    output_time: selectedOutputTime.value[values.index],
    from_date_time: props.deliveryPlanRecords[values.index].leaving_warehouse,
    to_date_time: props.deliveryPlanRecords[values.index].returning_warehouse,
    date_at_output_time: deliveryPlanDate,
    start_time_at_output_time: displayStartTime,
    distance_at_output_time: values.drivingDistance,
    driving_time_at_output_time: values.drivingTime,
    x_label: values.xLabel.join(','),
    distance_data: makeEmitData(values.distance),
  });
}

function makeEmitData(data: number[][]) {
  const result: {[key: string]: number} = {};
  data.forEach((item: number[]) => {
    const dateTime = formatDateTimeWithMilliseconds(new Date(item[0]))
    result[dateTime] = item[1];
  });

  return result;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.deliveryPlanRecords, (deliveryPlan, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "w-100 text-center mt-5 every-24hours-report-container"
      }, [
        _createVNode(PreviewHeader, {
          modelValue: selectedOutputTime.value[index],
          "onUpdate:modelValue": ($event: any) => ((selectedOutputTime.value[index]) = $event),
          index: index,
          deliveryPlan: deliveryPlan,
          downloading: props.downloading,
          chartDetails: chartDetails.value[index]
        }, null, 8, ["modelValue", "onUpdate:modelValue", "index", "deliveryPlan", "downloading", "chartDetails"]),
        _createVNode(PreviewCharts, {
          index: index,
          deliveryPlan: deliveryPlan,
          outPutTime: selectedOutputTime.value[index],
          onChangeDetailData: changeChartDetail
        }, null, 8, ["index", "deliveryPlan", "outPutTime"])
      ]))
    }), 128))
  ]))
}
}

})